import { Avatar, Button, Divider, Modal, Pagination, Table } from "antd";
import CommonTopDetails from "../CommonTopDetails";
import {
  DownOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import axiosInstance from "../../../api/Axios";
import { capitalizeWords } from "../../icons/ApplicationColor";
function formatTypeText(text) {
  if (!text) return "";
  // Replace underscores with spaces, lowercase everything, then capitalize each word
  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
const AddTrainersVirtual = ({
  visible,
  onCancel,
  org_id,
  id,
  CreateSuccessfull,
  CreateFailed,
}) => {
  const [selectedTrainerIds, setSelectedTrainerIds] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);

  // This is the combined, deduplicated selection
  const selectedRowIds = Array.from(
    new Set([...selectedTrainerIds, ...selectedUserIds])
  );
  console.log(selectedRowIds);
  const handleTrainerSelection = (selectedRowKeys) => {
    setSelectedTrainerIds(selectedRowKeys);
  };

  const handleUserSelection = (selectedRowKeys) => {
    setSelectedUserIds(selectedRowKeys);
  };

  const rowSelectionTrainers = {
    selectedRowKeys: selectedRowIds,
    onChange: handleTrainerSelection,
  };

  const rowSelectionUsers = {
    selectedRowKeys: selectedRowIds,
    onChange: handleUserSelection,
  };
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const [filterData, setFilterData] = useState({
    pageSize: 10,
    currentPage: 1,
    url: `/selecttrainer/?organization=${org_id}&exclude_course_id=${id}&role_deleted=False&organization_user_deleted=False&role=internal_trainer&role=external_trainer`,
    search: "",
    active: true,
    filter_url: "",
  });
  const { pageSize, currentPage, url, search, filter_url } = filterData;
  console.log(url);
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `&page_num=${currentPage}&items=${pageSize}&search=${search}${filter_url}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page_num=${currentPage}&items=${pageSize}${filter_url}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setData(res?.data?.data?.trainer_data || []);
        setItemsLength(res?.data?.data?.paginator?.count || 0);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    if (visible && id) {
      LoadUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, visible, id]);

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  const [data2, setData2] = useState([]);
  const [loading2, setLoading2] = useState(true);
  const [itemsLength2, setItemsLength2] = useState();
  const [filterData2, setFilterData2] = useState({
    pageSize2: 15,
    currentPage2: 1,
    url2: `/user/?organization=${org_id}&exclude_course_id=${id}&organization_user_archived=False`,
    search2: "",
    active2: true,
    filter_url2: "",
  });
  const { pageSize2, currentPage2, url2, search2, filter_url2 } = filterData2;
  const LoadUser2 = async () => {
    let passUrl = url2;
    let doNothing = false;
    if (search2?.length > 0) {
      if (search2.length > 1) {
        passUrl += `&page_num=${currentPage2}&items=${pageSize2}&search=${search2}${filter_url2}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page_num=${currentPage2}&items=${pageSize2}${filter_url2}`;
    }
    if (!doNothing) {
      setLoading2(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setData2(res?.data?.data?.User_data || []);
        setItemsLength2(res?.data?.data?.paginator?.count || 0);
        setLoading2(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    if (visible && id) {
      LoadUser2();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData2, visible, id]);
  const onShowSizeChange2 = (current, size) => {
    setFilterData2((prevData) => ({
      ...prevData,
      pageSize2: size,
    }));
  };

  const onPageChange2 = (page, pageSize) => {
    setFilterData2((prevData) => ({
      ...prevData,
      currentPage2: page,
    }));
  };
  const handleSearchChange2 = (event) => {
    setFilterData2((prevData) => ({
      ...prevData,
      search2: event.target.value,
      currentPage2: 1,
    }));
  };
  const [usersVisible, setUsersVisible] = useState(false);
  const columns = [
    {
      title: "Trainer Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 200,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            src={record?.profile_pic || null}
            icon={!record?.profile_pic && <UserOutlined />}
            alt={record?.first_name}
            size="small"
          />
          <span>
            {record?.first_name} {record?.last_name}
          </span>
        </div>
      ),
    },
    {
      title: "Phone No.",
      dataIndex: "phone_number",
      key: "phone_number  ",
      width: 150,
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 220,
    },
    {
      title: capitalizeWords("Type"),
      dataIndex: "type",
      key: "type",
      width: 150, // set width to 150px
      render: (text) => formatTypeText(text),
    },
  ];
  const columns2 = [
    {
      title: "User Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 200,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            src={record?.profile_pic || null}
            icon={!record?.profile_pic && <UserOutlined />}
            alt={record?.first_name}
            size="small"
          />
          <span>
            {record?.first_name} {record?.last_name}
          </span>
        </div>
      ),
    },
    {
      title: "Phone No.",
      dataIndex: "phone_number",
      key: "phone_number  ",
      width: 150,
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 220,
    },
    {
      title: capitalizeWords("Type"),
      dataIndex: "user_type",
      key: "user_type",
      width: 150, // set width to 150px
      render: (text) => formatTypeText(text),
    },
  ];
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const onFinish = async () => {
    //console.log(values);
    const payload = {
      course: id,
      users: selectedRowIds,
    };

    //console.log(newValues);
    try {
      await axiosInstance.post(`/coursetrainer/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull(null);
    } catch (err) {
      //console.log(err);
      CreateFailed(null);
    }
  };
  const handleCancel = () => {
    setUsersVisible(false);
    setData2([]);
    setData([]);
    setFilterData({
      pageSize: 10,
      currentPage: 1,
      url: `/selecttrainer/?organization=${org_id}&exclude_course_id=${id}&role_deleted=False&organization_user_deleted=False&role=internal_trainer&role=external_trainer`,
      search: "",
      active: true,
      filter_url: "",
    });
    setFilterData2({
      pageSize2: 10,
      currentPage2: 1,
      url2: `/user/?organization=${org_id}&exclude_course_id=${id}&organization_user_archived=False`,
      search2: "",
      active2: true,
      filter_url2: "",
    });
    setLoading(false);
    setLoading2(false);
    setItemsLength(0);
    setItemsLength2(0);
    setSelectedTrainerIds([]);
    setSelectedUserIds([]);
    onCancel();
  };

  return (
    <Modal open={visible} onCancel={handleCancel} footer={null} width={900}>
      <CommonTopDetails
        title={`Select From Available Trainers`}
        titleSuffix={`${itemsLength || 0} trainer(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={false}
        marginPass="35px"
        paddingInlinepass="10px"
      />

      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={loading}
        rowKey="id"
        size="small"
        className="table-container"
        style={{ margin: "1rem" }}
        scroll={{
          x: 300,
          y: 200,
        }}
        bordered
        rowSelection={rowSelectionTrainers}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger={false}
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
        {!usersVisible ? (
          <div
            style={{
              display: "flex",
              gap: "15px",
              marginLeft: "10px",
            }}
          >
            <Button key="back" onClick={() => setUsersVisible(true)}>
              <DownOutlined /> Choose From Users
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              onClick={onFinish}
              disabled={selectedRowIds.length === 0}
            >
              Add to Course <UsergroupAddOutlined />
            </Button>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      {usersVisible && (
        <>
          <Divider style={{ margin: "1rem" }} />
          <CommonTopDetails
            title={`Select From Available Users`}
            titleSuffix={`${itemsLength2 || 0} user(s)`}
            searchPlaceholder="Search by..."
            searchAction={handleSearchChange2}
            showAddButton={false}
            filterAction={false}
            marginPass="25px"
            paddingInlinepass="10px"
          />
          <Table
            columns={columns2}
            dataSource={data2}
            pagination={false}
            rowKey="id"
            size="small"
            loading={loading2}
            className="table-container"
            style={{ margin: "1rem" }}
            rowSelection={rowSelectionUsers}
            scroll={{
              x: 300,
              y: 200,
            }}
            bordered
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "1rem",
              marginBottom: "0.5rem",
            }}
          >
            <Pagination
              size="small"
              //   showSizeChanger
              onShowSizeChange={onShowSizeChange2}
              onChange={onPageChange2}
              pageSizeOptions={["5", "10", "15", "20", "50"]}
              //   showQuickJumper
              showSizeChanger={false}
              current={currentPage2}
              defaultPageSize={pageSize2}
              total={itemsLength2}
            />
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginRight: "10px" }}
              onClick={onFinish}
              disabled={selectedRowIds.length === 0}
            >
              Add to Course <UsergroupAddOutlined />
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default AddTrainersVirtual;
